import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

const initialState = 0;

export const appointmentCountSlice = createSlice({
  name: 'appointmentCount',
  initialState,
  reducers: {
    setCount: (state, action) => action.payload,
  },
});

// Action creators are generated for each case reducer function
export const { setCount } = appointmentCountSlice.actions;

export const getAppointmentCount = (state: RootState) => state.appointmentCount;

export default appointmentCountSlice.reducer;
